export default __webpack_public_path__ + "src/_images/ISA_Slide2.png";